import React, { useEffect, useContext } from "react";
import { AppContext } from "./AppContext";
import { getQueryParams } from "../utils/queryDataTransform";
import { updateOutbound, updateInbound } from "../actions/appActions";
import { signupContextReducer, defaultSignupState } from "../reducers/signupContextReducer";
import { useReducerWithLogging } from "../utils/useReducerWithLogging";
import { updateSignupParams } from "../actions/signupActions";

const SignupContext = React.createContext();

const useSignupContext = () => useContext(SignupContext);

const SignupContextProvider = props => {
    const {
        state: { step, inbound, outbound },
        dispatch: appDispatch,
    } = useContext(AppContext);

    const [state, dispatch] = useReducerWithLogging(signupContextReducer, defaultSignupState);

    //set signup params
    useEffect(() => {
        if ((inbound.planHandle || outbound.planHandle) && step > 0) {
            //only subscribe to signupParams after step 0
            let params = [inbound, outbound].map(
                item =>
                    item && {
                        planHandle: item.planHandle,
                        ...(item.allocation && { allocation: item.allocation }),
                    }
            );

            //set the initial plan handle and allocation signup params
            dispatch(updateSignupParams({ plans: params }));
        }
    }, [inbound, outbound]);

    //retrieve url parameters
    useEffect(() => {
        const getParams = getQueryParams(window.location.search);
        const inboundPlanHandle = getParams.get("inboundPlan");
        const inboundLimit = getParams.get("domainLimit");
        const outboundPlanHandle = getParams.get("outboundPlan");

        if (inboundPlanHandle) {
            appDispatch(
                updateInbound({
                    planHandle: inboundPlanHandle,
                    allocation: inboundLimit,
                })
            );
        }
        if (outboundPlanHandle) {
            appDispatch(updateOutbound({ planHandle: outboundPlanHandle }));
        }
    }, [window.location]);

    return (
        <SignupContext.Provider value={{ state, dispatch }}>
            {props.children}
        </SignupContext.Provider>
    );
};

const SignupContextConsumer = SignupContext.Consumer;

export { SignupContext, SignupContextProvider, SignupContextConsumer, useSignupContext };
